import { render, staticRenderFns } from "./TotalBookings.vue?vue&type=template&id=39d9d318&scoped=true"
import script from "./TotalBookings.vue?vue&type=script&lang=js"
export * from "./TotalBookings.vue?vue&type=script&lang=js"
import style0 from "./TotalBookings.vue?vue&type=style&index=0&id=39d9d318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d9d318",
  null
  
)

export default component.exports